// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"506a5245","150":"8c505b81","167":"c4841973","204":"184d2acd","522":"f4ced55b","523":"7a391673","577":"e475bf19","739":"656d0621","787":"37f0c89a","940":"4cf9e1d1","968":"a9626125"}[chunkId] + ".chunk.js";
};